import { useMemo } from 'react'

import { Page } from '@/components/layout/page/page.tsx'
import { useAccount } from '@/modules/accounts/hooks/useAccounts.ts'
import { PpvOverviewTable } from '@/modules/tracking/ppv/ui/PpvOverviewTable.tsx'

export const PpvTrackingOverviewPage = () => {
  const { userSettings } = useAccount()
  const shouldShowCents = useMemo(
    () => userSettings?.showCents,
    [userSettings?.showCents],
  )

  return (
    <Page>
      <PpvOverviewTable showCents={shouldShowCents} />
    </Page>
  )
}
